import React, { useState } from "react";
import { Observer } from "mobx-react";
import { useStores } from "../../store";
import { CiCirclePlus, CiSearch } from "react-icons/ci";
import Notification from "./Notification";
import Tooltip from "../reusble_components/tooltip";
import Connect from "./Connect";
export default function SearchBar({
  availableCredits,
  isDashboard,
  heading,
  notificationIcon,
  searchPlaceHolder,
  buttonText,
}) {
  const { UserStore, PopupStore } = useStores();
  function notify(onClick) {
    PopupStore.setNotification(true);
    if (onClick) {
      onClick();
    }
  }

  const userDetails = JSON.parse(localStorage.getItem("user"));
  const coins = userDetails?.coins;
  const denominator = 10;
  const freeInterviews = (coins / denominator).toFixed(0);

  const [isSearchOpen, setIsSearchOpen] = useState(true);

  const toggleSearch = () => {
    setIsSearchOpen((prevIsSearchOpen) => !prevIsSearchOpen);
  };

  const firstName = UserStore?.userDetails?.name || "";
  const formattedName =
    typeof firstName === "string" && firstName.length > 0
      ? firstName.split(" ")[0].charAt(0).toUpperCase() +
        firstName.split(" ")[0].slice(1).toLowerCase()
      : "";
  console.log(formattedName, "Nameee");

  return (
    <Observer>
      {() => (
        <>
          {PopupStore.notification && (
            <Notification
              popUpInitialValue={PopupStore.notification}
              handlePopup={() => {
                PopupStore.setNotification(false);
              }}
            />
          )}
          <div>
            {PopupStore.connectPopup && <Connect />}
            <div className="flex flex-col items-center md:flex md:flex-row md:justify-between md:items-center lg:flex lg:flex-row lg:justify-between lg:items-center h-32 lg:w-[95%] -mt-3">
              <p className="font-semibold  md:text-2xl lg:text-2xl ml-[30px] md:px-4 lg:p-6 w-[30%] lg:w[35%] ">
                Home Page
              </p>
              {/* Hi <span className="text-primary">{formattedName}</span>,
                Welcome to{" "}
                {name() === "Reaidy" ? (
                  <>
                    <span className="text-primary">R</span>eaidy{" "}
                  </>
                ) : (
                  name()
                )} */}
              <div
                onClick={() => notify()}
                className="relative flex bg-gray-300 md:items-center md:justify-center lg:w-[7%] md:h-12 md:w-20 lg:h-17 rounded-xl lg:rounded-3xl cursor-pointer py-2 ml-96 -mr-8 "
              >
                <Tooltip
                  id="notificationbtntooltip"
                  position="bottom"
                  content="Notifications"
                >
                  {notificationIcon}
                </Tooltip>
                {/* Badge */}
                <div className="absolute top-2 right-3 bg-orange-500 text-white text-xs font-bold w-4 h-4 flex items-center justify-center rounded-full">
                  2
                </div>
              </div>

              <div
                className={`flex items-center justify-evenly w-[70%] lg:w-[65%] mr-6 `}
              >
                <div
                  className={`flex lg:mr-0 w-[50%]  lg:w-[60%] squared border-2 border-primary rounded-lg -mr-8`}

                  // onMouseEnter={handleMouseEnter}
                  // onMouseLeave={handleMouseLeave}
                >
                  <div
                    className={`flex justify-between items-center  pl-1 h-11  w-full lg:h-14  `}
                  >
                    {/* <Tooltip id="searchbartooltip" position="bottom-end" content="Search"> */}
                    {isSearchOpen && (
                      <input
                        type="text"
                        placeholder={searchPlaceHolder}
                        // ref={searchValue}

                        className={`placeholder-gray-400  truncate text-base lg:text-xl outline-none pl-4 text-black h-10 scale-100 md:w-[80%]  `}
                      />
                    )}

                    {/* </Tooltip> */}
                    <CiSearch
                      className={`text-3xl lg:text-3xl text-primary  pr-[0%] lg:p-0 cursor-pointer ${
                        isSearchOpen
                          ? "md:w-20 lg:w-[10%] p-1"
                          : "w-[90%] scale-100"
                      }`}
                      onClick={toggleSearch}
                    />
                  </div>
                </div>
                {/* <div
                  className={`absolute right-32 lg:right-40 background-shadow hidden md:flex md:items-center md:justify-center  md:h-16 md:w-16 lg:w-24 lg:h-20 rounded-2xl lg:rounded-3XL cursor-pointer ${!isSearchOpen ? 'scale-100' : 'scale-0'
                    } transition-all duration-300 ease-in-out`}
                  onClick={toggleSearch}
                >
                  <Tooltip id="Searchtooltip" position="bottom" content="Search">
                    <CiSearch className="w-8 h-8 text-primary " />
                  </Tooltip>
                </div> */}
                {/* <div className="flex justify-between items-center w-[98%] px-1 h-16 lg:h-20">
                  <input
                    type="text"
                    placeholder="Search by Name, Role or Technology"
                    className={`placeholder-gray-300 truncate text-lg lg:text-2xl outline-none pl-4 text-black h-10 w-[85%] ${
                      isSearchOpen ? 'block' : 'hidden'
                    }`}
                  />
                </div>

                <div
                  className="absolute right-32 background-shadow hidden md:flex md:items-center md:justify-center md:h-16 md:w-16 lg:w-24 lg:h-20 rounded-2xl lg:rounded-3XL cursor-pointer"
                  onClick={toggleSearch}
                >
                  <CiSearch className="w-8 h-8" />
                </div> */}
                {/* <div
                  onClick={() => notify()}
                  className="flex bg-[#f1f1f1] md:items-center md:justify-center lg:w-[7%] md:h-14 md:w-14 lg:h-14 rounded-2xl lg:rounded-3XL cursor-pointer py-2 "
                >
                  <Tooltip
                    id="notificationbtntooltip"
                    position="bottom"
                    content="Notifications"
                  >
                    <MdNotifications className="w-8 h-8 " />
                  </Tooltip>
                </div> */}

                {/* <div className="flex items-center justify-between w-[30%] md:w-[27%] lg:w-[23%] h-14 lg:h-14 rounded-full bg-[#FFD7B9] ">
                  <div className="flex justify-between items-center text-black w-[70%]">
                    <p className="md:text-sm lg:text-lg text-xs md:font-medium lg:font-medium font-normal md:p-2 lg:p-2 p-1 md:px-6 lg:px-5 px-3">
                      Free Interviews
                    </p>
                  </div>
                  <div className=" border md:p-3 lg:p-5 flex justify-end w-[30%] lg:h-14 items-center rounded-full md:px-5 lg:px-6 px-4 md:h-14 bg-primary text-white mr-0">
                    <span className="flex justify-between items-center  md:text-lg lg:text-xl text-sm md:font-bold lg:font-bold font-normal">
                      {freeInterviews}
                    </span>
                  </div>
                </div> */}

                <button className=" flex bg-primary text-white px-8 py-3 rounded-lg gap-2 text-lg h-12 ">
                  <CiCirclePlus className="w-6 h-6" />
                  <p className="">Create new</p>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Observer>
  );
}

const SearchBarMobile = (props) => {
  const { UserStore } = useStores();
  const firstName = UserStore?.userDetails?.name || "";
  const formattedName =
    typeof firstName === "string" && firstName.length > 0
      ? firstName.split(" ")[0].charAt(0).toUpperCase() +
        firstName.split(" ")[0].slice(1).toLowerCase()
      : "";

  return (
    <div>
      <div></div>

      {/* <p className="font-bold  md:text-2xl lg:text-3xl mt-10  ml-[40px] md:ml-[40px] lg:ml-[40px] md:p-6 lg:p-8 py-4 ">
        Hai <span className="text-primary">{formattedName}</span>, welcome to{" "}
        {name() === "Reaidy" ? (
          <>
            <span className="text-primary">R</span>eaidy{" "}
          </>
        ) : (
          name()
        )}
      </p> */}
      {/* <div className="border ml-8 flex justify-center rounded-full w-[100%] overflow-hidden md:w-[42%] lg:w-[42%] border-black">
        <div className="flex justify-between items-center w-[98%]  h-12 ">
          <input
            type="text"
            placeholder="Search by Name, Role or Technology coming soon"
            // ref={searchValue}

            className=" placeholder-gray-300 truncate text-lg outline-none pl-4 h-10 w-[85%]"
          />
          <CiSearch className="text-4xl text-primary w-[10%] pr-[2%] " />
        </div>
      </div> */}
    </div>
  );
};

export { SearchBarMobile };
